import { render, staticRenderFns } from "./salesclerkAdd.vue?vue&type=template&id=5472333d&scoped=true&"
import script from "./salesclerkAdd.vue?vue&type=script&lang=js&"
export * from "./salesclerkAdd.vue?vue&type=script&lang=js&"
import style0 from "./salesclerkAdd.vue?vue&type=style&index=0&id=5472333d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472333d",
  null
  
)

export default component.exports